/**
 * Fetches a paginated list of games via our Next.js API routes.
 *
 * NOTE:
 * - Once the Backend handles the Games information, these calls will switch to the updated OpenAPI‑compliant endpoints.
 * - This file is temporary and will be removed once the migration to the new API is complete.
 */
import type { GameListResponseType } from './client';

export type Game = GameListResponseType extends (infer U)[] ? U : any;

export interface GamesListPaginatedResponse {
  games: Game[];
  total: number;
  page: number;
  limit: number;
  hasNextPage: boolean;
}

export interface FetchGamesListParams {
  categoryId: string;
  providerId: string;
  page: number;
  limit: number;
  tenantMachineName: string | null | undefined;
}

export const fetchGamesListWithPagination = async ({
  categoryId,
  providerId,
  page,
  limit,
  tenantMachineName,
}: FetchGamesListParams): Promise<GamesListPaginatedResponse> => {
  let apiUrl = `/api/games/list?page=${page}&limit=${limit}`;

  if (categoryId !== 'all-games') {
    apiUrl += `&categoryId=${encodeURIComponent(categoryId)}`;
  }

  if (providerId !== 'all-providers') {
    apiUrl += `&providerId=${encodeURIComponent(providerId)}`;
  }

  if (tenantMachineName) {
    apiUrl += `&tenantMachineName=${encodeURIComponent(tenantMachineName)}`;
  }

  const response = await fetch(apiUrl);

  if (!response.ok) {
    throw new Error('Network response was not ok for list');
  }

  return response.json();
};

export const fetchSearchResults = async ({
  searchQuery,
  tenantMachineName,
}: {
  searchQuery: string | null;
  tenantMachineName: string | null | undefined;
}): Promise<Game[]> => {
  const apiUrl = `/api/games/search?query=${encodeURIComponent(searchQuery || '')}&tenantMachineName=${encodeURIComponent(tenantMachineName || '')}`;

  const response = await fetch(apiUrl);

  if (!response.ok) {
    throw new Error('Network response was not ok for search');
  }

  return response.json();
};
